import {canReconnect} from './canReconnect';
import {
  RECONNECT_BACKOFF_FACTOR,
  RECONNECT_BASE_DELAY_MS,
  RECONNECT_MAX_DELAY_MS,
} from './subscriptionConstants';
import type {SubscriptionState} from './subscriptionTypes';

/**
 * Schedules the next reconnect with exponential backoff up to
 * `RECONNECT_MAX_DELAY_MS`. Suppressed while a refresh is in flight or after
 * the breaker has tripped.
 */
export const scheduleReconnect = (state: SubscriptionState) => {
  if (!canReconnect(state)) {
    return;
  }

  clearTimeout(state.reconnectTimer);
  const delay = Math.min(
    RECONNECT_BASE_DELAY_MS * RECONNECT_BACKOFF_FACTOR ** state.reconnectAttempts,
    RECONNECT_MAX_DELAY_MS
  );
  state.reconnectAttempts += 1;
  state.reconnectTimer = setTimeout(() => state.reopenSocket?.(), delay);
};
